import { Report } from '@mi-front/core';
import { Grid } from '@mui/material';
import React from 'react';
import { BaseReportInfo } from './BaseReportInfo';

export function BaseReportView({
  report,
  children,
  actions,
}: {
  report: Report;
  actions: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={9}>
        <BaseReportInfo report={report} />
        {children}
      </Grid>
      <Grid item xs={12} md={3}>
        {actions}
      </Grid>
    </Grid>
  );
}
